import { render, staticRenderFns } from "./OwnInfoView.vue?vue&type=template&id=13978ad4&"
import script from "./OwnInfoView.vue?vue&type=script&lang=ts&"
export * from "./OwnInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports